<template>
    <div>
        <div class="title-lable-error">
            <span class="ml-3"
                >You have exceeded the allowed machine threshold</span
            >
        </div>
        <div
            class="d-flex flex-row mt-3 ml-3"
            style="color: #757575; font-size: 0.85rem"
        >
            <div>
                Your account can only create a maximum of
                <span
                    style="font-size: 1rem; font-weight: 500; color: #42a5f5"
                    >{{ user.imageThreshold }}</span
                >
                machine.
            </div>
            <!-- <el-link
        :href="routeUrl.RECHARGE"
        class="ml-1"
        :underline="false"
        type="primary"
        target="_blank"
        >Recharge now</el-link
      > -->
        </div>
    </div>
</template>

<script>
// Lib
import { mapState } from "vuex";

// Extend
import base from "@/scripts/base";

export default {
    extends: base,

    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
};
</script>